import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect, ReactReduxContext, Provider } from 'react-redux';
import { clearStripeError, showStripeError } from 'redux/modules/billing';
import { createNewPartnerClient, setFormValue } from 'redux/modules/newClient';
import { submitNewClientForm } from 'redux/modules/teamManagement';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import NewLocation from '../NewLocation/NewLocation';
import NewClient from './NewClient';
import NewClientSuccess from './NewClientSuccess';
import tallyClientTotals from '../../../helpers/newClientSummaryTotals';
import { EmptyState, Spinner } from 'components';
import * as styles from './NewClient.scss';
var NewClientWrap = (_dec = connect(function (state) {
  return {
    auth: state.auth,
    config: state.config,
    organization: state.organization.current,
    theme: state.theme,
    step1Valid: state.newClient.validation.step1Valid,
    step2Valid: state.newClient.validation.step2Valid,
    formValues: state.newClient,
    step2FirstPass: state.newClient.validation.step2FirstPass,
    hasCommissionsAccount: state.billing.hasCommissionsAccount,
    loadingHasCommissionsAccount: state.billing.loadingHasCommissionsAccount,
    submittingNewClient: state.teamManagement.submittingNewClient
  };
}, {
  clearStripeError: clearStripeError,
  createNewPartnerClient: createNewPartnerClient,
  setFormValue: setFormValue,
  showStripeError: showStripeError,
  submitNewClientForm: submitNewClientForm
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewClientWrap, _Component);

  var _super = _createSuper(NewClientWrap);

  function NewClientWrap(props) {
    var _this2;

    _classCallCheck(this, NewClientWrap);

    _this2 = _super.call(this, props); // So testing can get past this (`Stripe` will not be in scope in Jest because it is loaded from a linked JS file)

    _defineProperty(_assertThisInitialized(_this2), "handleAddClientClick", function () {
      _this2.setState({
        newOrg: null,
        showNewClientDialog: true
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleStep2NextClick", function () {
      if (!_this2.state.creationInProgress) {
        _this2.setState({
          creationInProgress: true
        });
      }

      var _this2$props$formValu = _this2.props.formValues,
          orgConfig = _this2$props$formValu.orgConfig,
          orgDetails = _this2$props$formValu.orgDetails; // time to show any error messages on form

      if (_this2.props.step2FirstPass) {
        _this2.props.setFormValue('step2FirstPass', 'validation', false);
      } // validate form
      //            this.props.validateForm();
      // do stripe part


      if (_this2.props.step2Valid) {
        if (_this2.props.formValues.orgConfig.billingMethod !== 'existing_license') {
          _this2.handleConnectCC().then(function (stripeRes) {
            _this2.props.setFormValue('stripeTokenId', 'cc', stripeRes.id);

            _this2.setState({
              newClientFormStep: _this2.state.newClientFormStep + 1
            });
          });
        } else {
          // create using existing license
          var data = {
            contract: {
              firstName: orgDetails.firstName,
              lastName: orgDetails.lastName,
              email: orgDetails.email,
              businessName: orgDetails.businessName,
              phone: orgDetails.phone
            },
            address: {
              address1: orgDetails.address1,
              address2: orgDetails.address2,
              region: orgDetails.city,
              postcode: orgDetails.zipCode,
              locality: orgDetails.state
            },
            productId: 5
          };

          _this2.props.submitNewClientForm(_this2.props.theme.org, data).then(function (res) {
            _this2.setState({
              newOrg: res && res.data ? res.data : null,
              showNextStepsDialog: true,
              newClientFormStep: 1,
              showNewClientDialog: false,
              creationInProgress: false
            });
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "handleConnectCC", function () {
      var _this2$props$formValu2 = _this2.props.formValues,
          cc = _this2$props$formValu2.cc,
          orgDetails = _this2$props$formValu2.orgDetails;

      _this2.setState({
        checkoutInProgress: true
      });

      var _this = _assertThisInitialized(_this2);

      var stripePaymentObject = Stripe.card;
      return new Promise(function (resolve, reject) {
        stripePaymentObject.createToken({
          number: cc.cardNumber,
          exp_month: cc.expMonth,
          exp_year: cc.expYear,
          cvc: cc.cvc,
          name: orgDetails.name,
          address_zip: orgDetails.zipCode
        }, function (status, response) {
          _this.setState({
            checkoutInProgress: false
          });

          if (response.error) {
            return _this2.props.showStripeError(response.error);
          }

          if (status === 200) {
            console.log('it appears the stripe bit worked');

            _this2.props.clearStripeError();

            resolve(response);
          }

          console.log(status, response);
        });
      });
    });

    global.Stripe || global.window && global.window.Stripe ? Stripe.setPublishableKey(props.config.stripePublicKey) : null;
    _this2.state = {
      newOrg: null,
      showNextStepsDialog: false,
      showNewClientDialog: false,
      newClientFormStep: 1,
      checkoutInProgress: false,
      creatingNewClient: false,
      creationInProgress: false
    };
    return _this2;
  }

  _createClass(NewClientWrap, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setFormValue('step2Valid', 'validation', true);
      this.props.setFormValue('step2FirstPass', 'validation', true);
    }
    /** *******************************************************************************************
     EVENT HANDLERS
    ********************************************************************************************/

  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this3 = this;

      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          formValues = _this$props.formValues;
      var _this$props$formValue = this.props.formValues,
          orgConfig = _this$props$formValue.orgConfig,
          orgDetails = _this$props$formValue.orgDetails;
      var totals = contractInfo && orgConfig ? tallyClientTotals(contractInfo, orgConfig) : {};
      var connectCommissionsAccountActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Close",
        onClick: function onClick() {
          _this3.setState({
            showNewClientDialog: false,
            newClientFormStep: 1
          });
        },
        style: {
          marginRight: 24
        }
      })]; // CANCEL BUTTON

      var newClientDialogActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this3.setState({
            showNewClientDialog: false,
            newClientFormStep: 1
          });

          _this3.props.clearStripeError();
        },
        style: {
          marginRight: 24
        }
      })]; // BACK BUTTON

      if (this.state.newClientFormStep > 1) {
        newClientDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          label: "Back",
          onClick: function onClick() {
            _this3.setState({
              newClientFormStep: _this3.state.newClientFormStep - 1
            });
          },
          style: {
            marginRight: 24
          }
        }));
      }

      if (this.state.newClientFormStep === 1) {
        newClientDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          disabled: !this.props.step1Valid,
          secondary: true,
          label: "Next",
          onClick: function onClick() {
            _this3.setState({
              newClientFormStep: _this3.state.newClientFormStep + 1
            });
          }
        }));
      } else if (this.state.newClientFormStep === 2) {
        newClientDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: !this.props.step2Valid && !this.props.step2FirstPass || this.props.submittingNewClient,
          label: this.props.formValues.orgConfig.billingMethod === 'existing_license' ? 'Finish' : 'Next',
          onClick: this.handleStep2NextClick
        }));
      } else if (this.state.newClientFormStep === 3) {
        newClientDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: this.state.creatingNewClient,
          label: this.state.creatingNewClient ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spinner fa-spin",
            style: {
              fontSize: 20
            }
          }) : 'Finish',
          onClick: function onClick() {
            _this3.setState({
              creatingNewClient: true
            }); // create the org


            var data = Object.assign({}, _this3.props.formValues);
            data.orgConfig.licenseFee = totals.licenseFee;
            data.totals = totals;

            _this3.props.createNewPartnerClient(_this3.props.theme.org, data).then(function (newOrgRes) {
              _this3.setState({
                newOrg: newOrgRes && newOrgRes.data && newOrgRes.data.org ? newOrgRes.data.org : null,
                showNextStepsDialog: true,
                creatingNewClient: false,
                newClientFormStep: 1,
                showNewClientDialog: false
              });
            })["catch"](function (e) {
              _this3.setState({
                creatingNewClient: false
              });
            });
          }
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, "".concat(this.props.theme.org) !== '0' && /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Add Client",
        style: {
          marginRight: 32
        },
        onClick: this.handleAddClientClick
      }), this.props.hasCommissionsAccount ? /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          contentStyle: {
            maxWidth: 990,
            width: '97%'
          },
          title: "Add A New Client",
          autoScrollBodyContent: true,
          actions: newClientDialogActions,
          modal: true,
          open: _this3.state.showNewClientDialog
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(NewClient, {
          totals: totals,
          contractInfo: contractInfo,
          formStep: _this3.state.newClientFormStep
        })));
      }) : /*#__PURE__*/React.createElement(Dialog, {
        title: "Add A New Client",
        autoScrollBodyContent: true,
        actions: connectCommissionsAccountActions,
        modal: true,
        open: this.state.showNewClientDialog
      }, contractInfo && !this.props.loadingHasCommissionsAccount ? /*#__PURE__*/React.createElement("div", null, parseInt(this.props.auth.user.id) !== contractInfo.contract.ownerUserId ? /*#__PURE__*/React.createElement(EmptyState, {
        text: "No bank account connected for commission payments yet.",
        iconName: "fa fa-usd",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }) : /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: 'Connect Now',
        buttonOnClick: function buttonOnClick() {
          _this3.setState({
            showNewClientDialog: false
          });

          browserHistory.push('/user/commissions');
        },
        text: "No bank account connected for commission payments yet.",
        iconName: "fa fa-usd",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }), /*#__PURE__*/React.createElement("h2", {
        className: styles.noCommissionAccountText
      }, parseInt(this.props.auth.user.id) === contractInfo.contract.ownerUserId ? 'You' : "".concat(contractInfo.contract.firstName, " ").concat(contractInfo.contract.lastName), ' ', "must connect a bank account before you can add a client.")) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          actions: [/*#__PURE__*/React.createElement(RaisedButton, {
            label: "Close",
            onClick: function onClick() {
              _this3.setState({
                showNextStepsDialog: false
              });
            }
          })],
          title: "Next Steps",
          autoScrollBodyContent: true,
          open: _this3.state.showNextStepsDialog
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(NewClientSuccess, {
          newOrg: _this3.state.newOrg
        })));
      }));
    }
  }]);

  return NewClientWrap;
}(Component)) || _class);
export { NewClientWrap as default };